import { Component, OnInit } from '@angular/core';

import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare var lightGallery: any;
@Component({
  selector: 'app-photogallery',
  templateUrl: './photogallery.component.html',
  styleUrls: ['./photogallery.component.scss']
})
export class PhotogalleryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    
    /*---------------------------
    :: lightBox Gallery
    -----------------------------*/
    let galerias = document.getElementsByClassName('video-gallery');
    for (let i = 0; i < galerias.length; i++) {
      galerias[i].id = 'gal' + i; 
      lightGallery(document.getElementById('gal' + i), {
        selector: 'a',
      });
    } 
    
    let gall_image = document.getElementsByClassName('lightgallery');
    for (const gal of gall_image) {
      lightGallery(gal), {
        selector: 'a',
      }
    }

}
    // ===============================
  // TAB FILTER (YEAR WISE)
  // ===============================
 // =====================================
  // YEAR FILTER TABS
  // =====================================
  filterInnerTabs(filter: string, event: Event, containerId: string): void {

    const target = event.currentTarget as HTMLElement;
    const parentNav = target.closest('.nav');
    const cards = document.querySelectorAll(`#${containerId} > .col`);

    // Active tab
    parentNav?.querySelectorAll('.nav-link').forEach(link =>
      link.classList.remove('active')
    );
    target.classList.add('active');

    cards.forEach((card: any) => {
      const yearAttr = card.getAttribute('data-year');
      const year = Number(yearAttr);

      let show = false;

      if (filter === 'all') {
        show = true;
      }
      else if (filter === 'past-years') {
        show = !isNaN(year) && year < 2026;
      }
      else {
        show = yearAttr === filter;
      }

      card.classList.toggle('d-none', !show);
    });

  
  }


}
